<div class="flex items-center justify-center dialog-header ">
    Delete Field

    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>

<div class="dialog-content">
    <div *ngIf="editLeadFieldData?.is_fixed" class="text-center">
        <i class="pi pi-exclamation-triangle text-orange-500 text-4xl mb-3"></i>
        <div class="font-medium text-lg mb-2">Cannot Delete Fixed Field</div>
        <p class="text-gray-600">
            The field "{{ editLeadFieldData?.field_name }}" is a fixed field and cannot be deleted.
            <br/>You can only edit its label.
        </p>
    </div>

    <div *ngIf="!editLeadFieldData?.is_fixed" class="text-center font-medium text-lg">
        Are you sure you want to delete field: {{ editLeadFieldData?.field_name }}
    </div>

    <div class="flex gap-4 mt-7 justify-end">

        <p-button label="Cancel" severity="danger" variant="outlined" (click)="handleCloseDialog()"></p-button>
        <p-button *ngIf="!editLeadFieldData?.is_fixed" 
            label="Delete"
            severity="danger"
            icon="pi pi-trash"
            (click)="handleDelete()" 
            [disabled]="isLoading"
            [loading]="isLoading">
        </p-button>
        

    </div>

</div>